{
  "public.detail": {
    "search.placeholder": "搜索名单",
    "hero.shortlistBy": "入围名单 {{name}}",
    "empty.title": "无人入围",
    "empty.description": "通过选择要呈现给利益相关者的资源来构建您的候选列表",
    "filters.label": "筛选",
    "item.emptyValue": "无",
    "passwordProtection": {
      "enterPassword": "输入密码以查看候选名单",
      "placeholder": "输入密码",
      "viewShortlist": "查看候选名单"
    },
    "error": {
      "title": "搜索候选名单时出错"
    }
  },
  "GridViewItemGallery": {
    "editGallery": "编辑图库",
    "emptyGalleryTitle": "空图库",
    "emptyGalleryDescription": "为此资源添加媒体",
    "addMedia": "添加媒体"
  },
  "ShortlistVotes": {
    "upvote": "赞成",
    "downvote": "反对"
  },
  "GenericSearchFilterItem": {
    "filters": {
      "belongsToMe": "属于我",
      "createdAt": "创建于 {{date}} 之后",
      "publishedOnly": "仅已发布",
      "draftOnly": "仅草稿",
      "archived": "显示已归档",
      "contactId": "资源 {{contact}}",
      "between": "介于 {{startDate}} - {{endDate}} 之间",
      "tags": {
        "and": " 和 ",
        "more": " 更多",
        "any": "任意标签: {{tag}}",
        "match": "匹配标签: {{tags}}"
      }
    }
  },
  "ShortlistMediaSidebarPage": {
    "draft": "草稿",
    "votingDisabled": "候选名单未公布时禁止投票",
    "commentingDisabled": "候选名单未公布时禁止评论",
    "votingAndCommentingDisabled": "未发布时禁用投票和评论"
  },
  "MediaSidebar": {
    "Header": {
      "shortlistedCount": "已入围 {{count}} / {{totalBlocks}}"
    },
    "ResourceInfo": {
      "showDetails": "详情",
      "hideDetails": "隐藏"
    },
    "CommentList": {
      "noComments": "没有评论",
      "startConversation": "与团队成员就此人展开对话"
    },
    "CommentInput": {
      "writeComment": "写评论",
      "addComment": "添加评论"
    },
    "GuestNameChangeForm": {
      "title": "访客反馈",
      "description": "在下方输入您的姓名以留下反馈",
      "placeholder": "您的姓名",
      "saveChanges": "保存更改"
    },
    "GuestInfo": {
      "youAre": "您是 {{name}}",
      "change": "更改"
    }
  },
  "SetGuestNameModal": {
    "title": "设置访客名称",
    "description": "在投票或评论入围者之前，您需要告诉入围者您的身份",
    "yourName": "您的姓名",
    "saveName": "保存名称",
    "successfullyCreated": "创建成功",
    "guestNameSet": "访客名称已设置"
  }
}
